import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/datarecord.ts
function datarecord(title = "Database", options) {
	return Type.String({
		"ui:field": "datarecord",
		title,
		...options
	});
}

//#endregion
export { datarecord };
//# sourceMappingURL=datarecord.js.map